// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3TFs7","buttons":"Footer_buttons__1bhtD"};